/**
 * Helper aria-live : annonce dynamiquement un message aux lecteurs d'écran
 * sans interrompre la navigation clavier ni voler le focus.
 *
 * Crée (ou réutilise) une live region invisible attachée au body, écrit le
 * message dedans, puis nettoie après 1 s pour permettre la ré-annonce d'un
 * même message identique.
 */
export type AnnouncePriority = "polite" | "assertive";

const CLEAR_DELAY_MS = 1000;

export function announce(
  message: string,
  priority: AnnouncePriority = "polite",
): void {
  if (typeof document === "undefined") return;

  const id = `aria-live-${priority}`;
  let region = document.getElementById(id);

  if (!region) {
    region = document.createElement("div");
    region.id = id;
    region.setAttribute("role", "status");
    region.setAttribute("aria-live", priority);
    region.setAttribute("aria-atomic", "true");
    region.style.position = "absolute";
    region.style.left = "-10000px";
    region.style.width = "1px";
    region.style.height = "1px";
    region.style.overflow = "hidden";
    document.body.appendChild(region);
  }

  region.textContent = message;

  setTimeout(() => {
    if (region && region.textContent === message) {
      region.textContent = "";
    }
  }, CLEAR_DELAY_MS);
}
